export default __webpack_public_path__ + "static/media/typescript-original.8aa2c2d0.svg";